<template>
  <div
    v-if="logs.length"
    class="timing-logs"
  >
    <div
      v-for="(log, index) in logs"
      :key="index"
      class="timing-logs__item"
    >
      <span class="timing-logs__marker" />
      <div class="timing-logs__content">
        <div class="timing-logs__head">
          <job-status-badge
            :status="log.status"
            size="sm"
            :animated="false"
          />
          <span class="timing-logs__time">
            {{ formatDateTimeDetailed(log.startDateTime) }}
          </span>
        </div>
        <div
          v-if="log.messageComment"
          class="timing-logs__message"
        >
          {{ log.messageComment }}
        </div>
      </div>
    </div>
  </div>
  <div
    v-else
    class="timing-logs__empty"
  >
    {{ emptyText }}
  </div>
</template>

<script>
import JobStatusBadge from './JobStatusBadge.vue'

/**
 * Vertical timeline for timing logs. The desktop table has four columns which
 * force a horizontal scroll on a phone, so small screens get this instead.
 */
export default {
  name: 'TimingLogsList',
  components: {
    JobStatusBadge,
  },
  props: {
    logs: {
      type: Array,
      default: () => [],
    },
    emptyText: {
      type: String,
      default: 'No timing logs yet.',
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/variables';

.timing-logs {
  padding: 4px 0;

  &__item {
    position: relative;
    display: flex;
    padding-bottom: 14px;

    &:last-child {
      padding-bottom: 0;

      .timing-logs__marker::after {
        display: none;
      }
    }
  }

  &__marker {
    position: relative;
    flex: 0 0 auto;
    width: 8px;
    height: 8px;
    margin: 6px 12px 0 0;
    border-radius: 50%;
    background-color: $gray-500;

    &::after {
      content: '';
      position: absolute;
      top: 14px;
      left: 3px;
      width: 2px;
      height: calc(100% + 14px);
      background-color: $gray-1234;
    }
  }

  &__content {
    flex: 1 1 auto;
    min-width: 0;
  }

  &__head {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }

  &__time {
    font-size: 11px;
    color: $blue-800;
  }

  &__message {
    margin-top: 4px;
    font-size: 13px;
    color: $blue-700;
    overflow-wrap: anywhere;
  }

  &__empty {
    padding: 16px 0;
    font-size: 13px;
    color: $blue-800;
    text-align: center;
  }
}
</style>
